(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hg-variant-color-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const seeMoreButton = window.innerWidth < 768 ? document.querySelectorAll('.see-more-button')[6] : document.querySelectorAll('.see-more-button')[8];
    const seeLessButton = document.querySelector('.see-less-button');
    const colorChoiceContainer = document.querySelector('.color-choice--inner');
    console.log('Color choice container:', colorChoiceContainer);
    console.log('See more button:', seeMoreButton);
    if (seeMoreButton) {
      seeMoreButton.addEventListener('click', function() {
        colorChoiceContainer.classList.add('expanded');
      });
    }

    if (seeLessButton) {
      seeLessButton.addEventListener('click', function() {
        colorChoiceContainer.classList.remove('expanded');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
